import React, { Component } from 'react';
import { observer } from 'mobx-react';
import ProgressText from '../../../components/progress-text/Progress';
import Button from '../../../components/button/Button';
import SubContent from '../../../components/sub-content/SubContent';
import Toast from '../../../components/toast/Toast';

class FixSecond extends Component {
  constructor(props) {
    super(props);
    this.state = {
      status: 'default'
    };
  }

  componentWillUnmount() {
    this.props.store.stopTask();
    this.clearTasks();
  }

  clearTasks() {
    this.props.store.done = [];
  }

  runTasks() {
    const tasks = this.props.store.tasksSeond;
    const promises = tasks.map((item => item.execute));
    let stopIndex = null;

    promises.reduce(
      (previousPromise, nextPromise, index) => {
        return previousPromise
          .then(() => {
            this.props.store.addTasks(tasks[index]);
            if (index > 0) {
              this.props.store.done[index - 1].status = 'success';
            }
            this.props.store.done[index].status = 'loading';
            return nextPromise();
          })
          .catch((error) => {
            if (stopIndex === null) stopIndex = index;
            // 如果已经报错，reduce仍然会按照执行栈依次执行错误，直到栈空
            if (index > stopIndex) {
              return Promise.reject(error);
            }
            this.props.store.done[index].status = 'error';
            if (tasks[index].abort === '0') {
              return Promise.resolve();
            }
            return Promise.reject(error);
          });
      },
      Promise.resolve()
    ).then(() => {
      this.props.store.done[tasks.length - 1].status = 'success';

      this.setState({
        status: 'success'
      });
    }).catch((error) => {
      this.setState({
        status: 'error'
      });

      Toast.fail(error.toString());
    });
  }

  reRunTasks() {
    this.clearTasks();
    this.setState({
      status: 'default'
    });

    this.startDebug();
  }

  startDebug() {
    this.setState({
      status: 'loading'
    });
    this.runTasks();
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">修复二</h4>
        <SubContent>
          {
            this.state.status === 'default'
            && <Button type="text" onClick={() => this.startDebug()}>开始修复</Button>
          }
          {this.props.store.done.map(item => (
            <ProgressText
              key={item.name}
              text={item.text}
              success={item.success}
              error={item.error}
              status={item.status}
              small
              canBack
            />
          ))}
        </SubContent>
      </div>
    );
  }
}

export default observer(FixSecond);
